import React from 'react'
import styles from './header.module.css'

export default function Header(props) {
    return (
        // <div className={`${styles.site}`}>
        //     <h1>{props.name}</h1>
        // </div>
        <div class="div">
            <svg viewBox="0 0 600 151" xmlns="http://www.w3.org/2000/svg">
                <path fill="rgba(253, 181, 213, 1)" d="M 0 70 C 228 70 228 110 456 110 L 456 110 L 456 0 L 0 0 Z" stroke-width="0"></path>
                <path fill="rgba(253, 181, 213, 1)" d="M 455 110 C 672.5 110 672.5 24 890 24 L 890 24 L 890 0 L 455 0 Z" stroke-width="0"></path>
            </svg>
        </div>
    )
}
